import React from 'react';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import { Desktop, Mobile } from 'components/Responsive';
import { UpSellOption } from 'models/upsell';

import UpSellDesktop from './components/UpsellDesktop';
import UpSellMobile from './components/UpsellMobile';

interface Props {
  show: boolean;
  onClose: () => void;
  onSelect: (optionId: number) => void;
  onChange: (optionId: number) => void;
  options: UpSellOption[];
  loading: boolean;
}

const UpSellOptions = ({ show, onClose, onSelect, onChange, options, loading }: Props) => (
  <>
    <Mobile>
      <UpSellMobile
        options={options}
        onClose={onClose}
        show={show}
        onSelect={(optionId) => {
          onChange(optionId);
          onSelect(optionId);
        }}
        loading={loading}
      />
    </Mobile>

    <Desktop>
      <ApplicationOverlayContent show={show} width={900} onClose={onClose} testId="flight-upsell">
        <UpSellDesktop options={options} onClose={onClose} onSelect={onSelect} onChange={onChange} loading={loading} />
      </ApplicationOverlayContent>
    </Desktop>
  </>
);

export default UpSellOptions;
